export default __webpack_public_path__ + "assets/ef0526530a885066ada68e94d83663c0.svg";